import {Component, OnDestroy, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import VideoState from '../../../shared/stores/root-store/video.state';
import {
    VideoResolutionMenuVisibilityAction,
    VideoUserResolutionUpdateAction
} from '../../../shared/stores/root-store/actions/timeline.action';
import {
    selectNotAvailableResolution,
    selectUserResolutionFromState,
    selectVideoClipResolutions
} from '../../../shared/stores/root-store/selectors/video.selector';
import {EventEnum} from '../../../../enums/event.enum';
import {EventTrackingService} from '../../../shared/services/event-tracking.service';
import {Subscription} from 'rxjs';

@Component({
    selector: 'eocm-resolution',
    templateUrl: './resolution.component.html',
    styleUrls: ['./resolution.component.scss']
})
export class ResolutionComponent implements OnInit, OnDestroy {
    resolutions: string[] = [];
    notAvailableResolutions: string[] = [];
    hdResolutions: string[] = ['720p', '1080p', '1440p'];
    current: string;
    private _subs: Subscription[] = [];

    constructor(
        private store: Store<{ video: VideoState }>,
        private tracking: EventTrackingService
    ) {
    }

    ngOnInit() {
        this._subs.push(this.store.select(selectUserResolutionFromState).subscribe(resolution => this.current = resolution));
        this._subs.push(
            this.store.select(selectVideoClipResolutions).subscribe(resolutions => this.resolutions = resolutions));
        this._subs.push(
            this.store.select(selectNotAvailableResolution).subscribe(resolutions => this.notAvailableResolutions = resolutions));

    }

    applyResolution(resolution: string) {
        this.current = resolution;
        this.tracking.track(EventEnum.ResolutionChanged, {
            resolution
        });
        this.store.dispatch(VideoUserResolutionUpdateAction({
            changedResolution: this.current
        }));
    }

    menuOpen() {
        this.store.dispatch(VideoResolutionMenuVisibilityAction({
            changedVisibility: true
        }));
    }

    isNotAvailable(resolution: string): boolean {
        return !!this.notAvailableResolutions.find(notAvailable => notAvailable === resolution);
    }

    menuClose() {
        this.store.dispatch(VideoResolutionMenuVisibilityAction({
            changedVisibility: false
        }));
    }

    ngOnDestroy() {
        this._subs.forEach((subs) => {
            subs.unsubscribe();
        });
    }
}
